var _defs, _linearGradient, _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeTypeReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 24,
    cy: 24,
    r: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 23.896,
    cy: 8.371,
    r: 35.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8cdd1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 40.854,
    x2: 45.561,
    y1: 21.146,
    y2: 25.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 10.565,
    x2: 37.435,
    y1: 10.565,
    y2: 37.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffee9e",
      fillOpacity: 1
    },
    d: "M39 16v25a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h17l11 11z",
    fill: "#50e6ff"
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 -3890)",
    y2: -3900.4,
    y1: -3905.471,
    x2: 33.6,
    x1: 28.529,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3079d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297cd2",
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5db62",
      fillOpacity: 1
    },
    d: "M28 5v9a2 2 0 0 0 2 2h9L28 5z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.74 27.744) scale(.42105)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#b)"
    },
    d: "M44 27h-2v-7h2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#c)"
    },
    fill: "url(#c)",
    r: 19,
    cy: 24,
    cx: 24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#d)"
    },
    fill: "url(#d)",
    r: 17.5,
    cy: 24,
    cx: 24
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#e)"
    },
    fill: "url(#e)",
    r: 16,
    cy: 24,
    cx: 24
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 36.75a.75.75 0 0 1-.75-.75V24a.75.75 0 0 1 1.5 0v12a.75.75 0 0 1-.75.75z",
    fill: "#d83b01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.75a.75.75 0 0 1-.53-1.281l8.485-8.485a.75.75 0 1 1 1.061 1.061L24.53 24.53a.744.744 0 0 1-.53.22z",
    fill: "#45494d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 25.25c-.181 0-.365-.039-.54-.123l-7.787-3.735a1.25 1.25 0 1 1 1.081-2.254l7.787 3.735a1.25 1.25 0 0 1-.541 2.377z",
    fill: "#45494d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#1e2021",
    r: 2,
    cy: 24,
    cx: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeTypeReminder);
export default __webpack_public_path__ + "static/media/noticeTypeReminder.f375eeb9bc100be2d382c8d0ddb3277e.svg";
export { ForwardRef as ReactComponent };